/**
 * CashierLotteryTab — three sub-tabs mirroring the operator console but
 * scoped to this cashier's sub-group:
 *
 *   • Place Ticket — existing AdminLotteryHelperPanel (with /cashier/players)
 *   • Drawings    — recent winning numbers for the storefront's enabled states
 *   • Tickets     — every ticket placed for their sub-group OR by them,
 *                   with scan viewer + flag/unflag (auto-refresh every 20s)
 */
import { useState } from 'react';
import { AdminLotteryHelperPanel } from '../pages/admin/AdminLotteryHelperPanel';
import OperatorRecentDraws from './OperatorRecentDraws';
import OperatorTicketsList from './OperatorTicketsList';
import LotteryLimitsPanel from './LotteryLimitsPanel';
import { TicketIcon, Trophy, ListChecks, ShieldCheck } from 'lucide-react';

const SUB_TABS = [
    { key: 'place',    label: 'Place Ticket', icon: TicketIcon },
    { key: 'drawings', label: 'Drawings',     icon: Trophy },
    { key: 'tickets',  label: 'My Tickets',   icon: ListChecks },
    { key: 'limits',   label: 'Limits',       icon: ShieldCheck },
];

const CashierLotteryTab = () => {
    const [active, setActive] = useState('place');
    return (
        <div className="space-y-5" data-testid="cashier-lottery-tab">
            <div className="flex items-center gap-2 border-b border-zinc-800 overflow-x-auto">
                {SUB_TABS.map(t => {
                    const Icon = t.icon;
                    const on = active === t.key;
                    return (
                        <button key={t.key}
                            onClick={() => setActive(t.key)}
                            data-testid={`cashier-lottery-subtab-${t.key}`}
                            className={`relative px-4 py-2.5 text-sm font-medium whitespace-nowrap transition
                                ${on ? 'text-emerald-300' : 'text-zinc-500 hover:text-zinc-300'}`}>
                            <span className="inline-flex items-center gap-1.5">
                                <Icon className="w-3.5 h-3.5" /> {t.label}
                            </span>
                            {on && <span className="absolute left-2 right-2 bottom-0 h-[2px] bg-emerald-400 rounded-full" />}
                        </button>
                    );
                })}
            </div>

            {active === 'place'    && <AdminLotteryHelperPanel playersEndpoint="/cashier/players" />}
            {active === 'drawings' && <OperatorRecentDraws endpoint="/cashier/lottery/draws" />}
            {active === 'tickets'  && (
                <OperatorTicketsList
                    listEndpoint="/cashier/lottery/tickets"
                    scanEndpoint="/cashier/lottery/scans"
                />
            )}
            {active === 'limits'   && <LotteryLimitsPanel />}
        </div>
    );
};

export default CashierLotteryTab;
